const PickupPage = () => {
  return <div>Pickup</div>;
};

export default PickupPage;
